<template>
    <div class="app-sidebar">
        <xc-menu-item
            v-for="(item, key) in data"
            :data="item"
            :key="key"
            :labelKey='labelKey'
            :idKey='idKey'
            :urlPrefix='urlPrefix'
            :select="select"
            :topId="item[idKey]"
            @open="open"
            @close="close"
        />
    </div>
</template>


<script>
import XcMenuItem from './MenuItem.vue';

export default {
    name: 'XcSidebar',
    props: {
        data: {
            type: Array,
            default: function () {
                return []
            }
        },
        labelKey: {
            default: 'label',
        },
        idKey: {
            default: 'id',
        },
        urlPrefix: {
            type: String,
            default: '',
        },
    },
    components: {
        XcMenuItem
    },
    data() {
        return {
            index: null,

            menuList: [],
            openId: null,
            selectId: null,
            openId: null,
        }
    },
    created() {
    },
    methods: {
        // 初始化数据
        initData() {

        },
        open(data) {
            const newData = this.data.map(v => {
                if (data[this.idKey] == v[this.idKey]) {
                    this.openId = data[this.idKey];
                    v.open = true;
                }

                return v;
            })

            this.$emit("update:data", newData);
        },
        close(data) {
            const newData = this.data.map(v => {
                if (data[this.idKey] == v[this.idKey]) {
                    v.open = false;
                }

                return v;
            })

            this.$emit("update:data", newData);
        },
        select(data,topId) {
            const newData = this.mapList(item => {
                if (data[this.idKey] == item[this.idKey]) {
                    item.active = true;
                } else {
                    item.active = false;
                }

                if (topId == item[this.idKey]) {
                    item.open = true;
                } else {
                    item.open = false;
                }

                return item;
            })

            this.$emit('update:data', newData);
            this.$emit("select", data);
        },
        mapList(run) {
            // return this.data.map(v => {
            //     v = run(v);

            //     if (v.children) v.children.map(v => {
            //         v = run(v);
            //     })

            //     return v;
            // })

            function each(data) {
                data.map((v) => {
                    v = run(v);

                    if (v.children) {
                        v.children = each(v.children)
                    }

                    return v;
                })

                return data;
            }

            return each(this.data)
        }
    }
}
</script>

<style scoped lang="scss">
</style>

